<template>
    <div class="addProcessInformationBox">
        <div class="head">
            <el-breadcrumb style="margin: auto auto auto 20px;" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: 'ProcessInformation' }">工艺信息</el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.params.key ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="content">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" size="small"
                     class="demo-ruleForm" style="width: 55%; margin-left: 15%">
                <el-form-item label="企业编码" prop="companyId">
                    <el-input v-model="ruleForm.companyId" placeholder="请输入企业编码"/>
                </el-form-item>
                <el-form-item label="工艺编码" prop="technologyNum">
                    <el-input v-model="ruleForm.technologyNum" placeholder="请输入工艺编码"/>
                </el-form-item>
                <el-form-item label="生产工艺名称" prop="technologyName">
                    <el-input v-model="ruleForm.technologyName" placeholder="请输入工艺名称"/>
                </el-form-item>
                <el-form-item label="反应类型" prop="reactionType">
                    <el-input v-model="ruleForm.reactionType" placeholder="请输入反应类型"/>
                </el-form-item>
                <el-form-item label="最终产品" prop="finalProduct">
                    <el-input v-model="ruleForm.finalProduct" placeholder="请输入最终产品"/>
                </el-form-item>
                <el-form-item label="最终产品物质形态" prop="finalProductForm">
                    <el-select v-model="ruleForm.finalProductForm" style="width: 100%">
                        <el-option v-for="itemp in productTypeList" :key="itemp.id" :value="itemp.id"
                                   :label="itemp.name"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="中间产品">
                    <el-input v-model="ruleForm.middleProduct" placeholder=""/>
                </el-form-item>
                <el-form-item label="中间产品物质形态">
                    <el-select v-model="ruleForm.middleProductForm" style="width: 100%">
                        <el-option label="固体" :value="1"/>
                        <el-option label="液体" :value="2"/>
                        <el-option label="气体" :value="3"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="重点监控单元" prop="emphasisSu">
                    <el-input v-model="ruleForm.emphasisSu" placeholder="请输入重点监控单元"/>
                </el-form-item>
                <el-form-item label="工艺危险特点" prop="riskCodes">
                    <el-input v-model="ruleForm.riskCodes" placeholder="请输入工艺危险特点"/>
                </el-form-item>
                <el-form-item label="重点监控工艺参数" prop="technologyParameter">
                    <el-input v-model="ruleForm.technologyParameter" placeholder="请输入重点监控工艺参数"/>
                </el-form-item>
                <el-form-item label="控制方式" prop="controlMode">
                    <el-input v-model="ruleForm.controlMode" placeholder="请输入控制方式"/>
                </el-form-item>
                <el-form-item label="自动控制措施" prop="controlMeasures">
                    <el-input v-model="ruleForm.controlMeasures" placeholder="请输入自动控制措施"/>
                </el-form-item>
                <el-form-item label="是否重点监管化工工艺" prop="supervise">
                    <el-radio-group v-model="ruleForm.supervise" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="岗位操作人数" prop="postEmp">
                    <el-input v-model="ruleForm.postEmp" placeholder="岗位操作人数" type="number"/>
                </el-form-item>
                <el-form-item label="持证人数" prop="havaCerEmp">
                    <el-input v-model="ruleForm.havaCerEmp" placeholder="持证人数" type="number"/>
                </el-form-item>
                <el-form-item label="技术来源">
                    <el-select v-model="ruleForm.jsly" style="width: 100%">
                        <el-option label="自行研发" :value="1"/>
                        <el-option label="技术转让" :value="2"/>
                        <el-option label="其他" :value="3"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="设计单位">
                    <el-input v-model="ruleForm.designOrganization"/>
                </el-form-item>
                <el-form-item label="工艺系统简况" prop="intro">
                    <el-input v-model="ruleForm.intro" placeholder="请输入工艺系统简况"/>
                </el-form-item>
                <el-form-item label="设计单位资质等级" prop="designOrganizationLevel">
                    <el-input v-model="ruleForm.designOrganizationLevel" placeholder="请输入设计单位资质等级"/>
                </el-form-item>
                <el-form-item label="是否满足国家规定的要求" prop="sfmzgjgdyq">
                    <el-radio-group v-model="ruleForm.sfmzgjgdyq" size="small">
                        <el-radio-button :label="0">否</el-radio-button>
                        <el-radio-button :label="1">是</el-radio-button>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="" style="margin-top: 40px">
                    <el-button type="primary" style="width: 100%" @click="submit">保存</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import {processInfoAdd, processInfoEdit} from "@/api/processManager"

    export default {
        name: 'AddProcessInformation',
        data() {
            return {
                ruleForm: {},
                rules: {
                    companyId: [{required: true, message: '请输入'}],
                    technologyNum: [{required: true, message: '请输入'}],
                    technologyName: [{required: true, message: '请输入'}],
                    reactionType: [{required: true, message: '请输入'}],
                    finalProduct: [{required: true, message: '请输入'}],
                    finalProductForm: [{required: true, message: '请输入'}],
                    emphasisSu: [{required: true, message: '请输入'}],
                    riskCodes: [{required: true, message: '请输入'}],
                    technologyParameter: [{required: true, message: '请输入'}],
                    controlMode: [{required: true, message: '请输入'}],
                    controlMeasures: [{required: true, message: '请输入'}],
                    supervise: [{required: true, message: '请选择'}],
                    postEmp: [{required: true, message: '请输入'}],
                    havaCerEmp: [{required: true, message: '请输入'}],
                    intro: [{required: true, message: '请输入'}],
                    designOrganizationLevel: [{required: true, message: '请输入'}],
                    sfmzgjgdyq: [{required: true, message: '请选择'}],
                },
                productTypeList: [
                    {id: 1, name: '固态'},
                    {id: 2, name: '液态'},
                    {id: 3, name: '气态'},
                    {id: 4, name: '等离子态'},
                ]
            }
        },
        created() {
            let obj = JSON.parse(localStorage.getItem('D3Config'))
            this.$set(this.ruleForm, 'companyId', obj.code)
            if (this.$route.params.key) {
                this.ruleForm = this.$route.params.key
            }
        },
        methods: {
            // 保存
            submit() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        // 编辑
                        if (this.$route.params.key) {
                            processInfoEdit({...this.ruleForm}).then(res => {
                                this.$message.success('保存成功')
                                this.$router.push('ProcessInformation')
                            })
                        }
                        // 新增
                        else {
                            processInfoAdd({...this.ruleForm}).then(res => {
                                this.$message.success('保存成功')
                                this.$router.push('ProcessInformation')
                            })
                        }
                    } else {
                        return false;
                    }
                });
            }
        },
        deactivated() { //路由组件失活时时执行函数
            this.$destroy() //路由组件失活时 销毁组件 再次打开重载组件
        }
    }
</script>

<style scoped>
    .addProcessInformationBox /deep/ .el-form-item {
        margin-bottom: 25px
    }
</style>
